import * as Yup from 'yup';

export const feedbackValidationSchema = (useRecaptcha) => {
    const schema = Yup.object().shape({
        name: Yup.string()
            .required( 'Заполните поле' ),
        // phone: Yup.string()
        //     .matches(phoneRegexp, 'Неверный формат телефона')
        //     .required( 'Заполните поле' ),
        description: Yup.string()
            .required( 'Заполните поле' ),
        acceptConditions: Yup.boolean()
            .required('Нужно согласие на обработку персональных данных')
            .oneOf([true], 'Нужно согласие на обработку персональных данных'),
    });

    const recaptchaSchema = Yup.object().shape({
        recaptcha: Yup.string().required()
    });

    if (useRecaptcha) {
        schema.concat(recaptchaSchema);
    }

    return schema;
}
